import React, { useState, useEffect } from 'react';
import { statsAPI } from '../api';

function Home() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await statsAPI.get();
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('加载统计失败:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>加载中...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>欢迎回来！</h1>
        <p>这里是您的营销活动概览</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>总营销活动</h3>
          <p>{stats?.total_campaigns || 0}</p>
        </div>

        <div className="stat-card">
          <h3>收件人总数</h3>
          <p>{stats?.total_recipients || 0}</p>
        </div>

        <div className="stat-card">
          <h3>已发送邮件</h3>
          <p>{stats?.total_emails_sent || 0}</p>
        </div>

        <div className="stat-card">
          <h3>活跃收件人</h3>
          <p>{stats?.active_recipients || 0}</p>
        </div>

        <div className="stat-card">
          <h3>已回复</h3>
          <p>{stats?.replied_recipients || 0}</p>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>快速开始</h2>
        </div>
        <div style={{ padding: '20px 0' }}>
          <h3 style={{ marginBottom: '15px', color: '#333' }}>开始使用邮件营销系统：</h3>
          <ol style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>
              <strong>添加发件邮箱：</strong>在"发件邮箱"页面添加您的发送邮箱（如 ethan@serenejade.com）
            </li>
            <li>
              <strong>管理收件人：</strong>在"收件人管理"页面添加您的目标收件人，并为他们打上标签
            </li>
            <li>
              <strong>创建营销活动：</strong>在"营销活动"页面创建新的营销活动，设置邮件内容和收件人
            </li>
            <li>
              <strong>配置Follow-up：</strong>为活动设置自动Follow-up，系统会定期发送跟进邮件
            </li>
            <li>
              <strong>查看日志：</strong>在"邮件日志"页面查看所有发送记录和状态
            </li>
          </ol>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>系统特性</h2>
        </div>
        <div style={{ padding: '20px 0' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div>
              <h4 style={{ color: '#3498db', marginBottom: '10px' }}>✉️ 一对一发送</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                所有邮件都是单独发送给每个收件人，确保个性化体验
              </p>
            </div>
            <div>
              <h4 style={{ color: '#2ecc71', marginBottom: '10px' }}>🔄 自动Follow-up</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                设置定时跟进邮件，自动在指定时间后发送
              </p>
            </div>
            <div>
              <h4 style={{ color: '#e74c3c', marginBottom: '10px' }}>🎯 智能停止</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                当收件人回复或状态改变时，自动停止Follow-up
              </p>
            </div>
            <div>
              <h4 style={{ color: '#f39c12', marginBottom: '10px' }}>📊 详细日志</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                完整记录每封邮件的发送状态和结果
              </p>
            </div>
            <div>
              <h4 style={{ color: '#9b59b6', marginBottom: '10px' }}>🏷️ 标签管理</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                为收件人添加标签，便于分类和筛选
              </p>
            </div>
            <div>
              <h4 style={{ color: '#34495e', marginBottom: '10px' }}>📧 CC/BCC支持</h4>
              <p style={{ fontSize: '14px', color: '#666' }}>
                支持抄送和密送，灵活配置邮件接收方
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;

